'use strict';

var formHelpers = require('base/checkout/formErrors');
var shippingHelpers = require('base/checkout/shipping');

/**
 * Updates states on country change
 * @param {Object} countrySelect - country element
 */
function updateStateOptions(countrySelect) {
    var country = $(countrySelect);
    if (country.length === 0) {
        return;
    }

    var form = country.closest('form');
    var countryVal = country.val();
    if (!countryVal || countryVal.toLowerCase() === 'select country') {
        countryVal = window.Countries.defaultCountry;
    }

    var c = window.Countries[countryVal];
    if ($.isEmptyObject(c)) {
        return;
    }

    // set state the label text
    var stateField = form.find('select[name$="_stateCode"]');
    var stateRegionMsg = window.resources.properties.stateMissingMessage +' '+ c.regionLabel;
    stateField.closest('.form-group').find('label').html(c.regionLabel);
    stateField.closest('.form-group').find('.invalid-feedback').html(stateRegionMsg);
    stateField.closest('.form-group').find('.form-control').attr('data-missing-error', stateRegionMsg);

    // set the zip code label text
    var postalField = form.find('input[name$="_postalCode"]');
    var postalRegionMsg = window.resources.properties.zipcodeMissingMessage +' '+ c.postalLabel.replace('*', '');
    postalField.closest('.form-group').find('label').html(c.postalLabel);
    postalField.closest('.form-group').find('input').attr('placeholder', c.postalLabel);
    postalField.closest('.form-group').find('.invalid-feedback').html(postalRegionMsg);
    postalField.closest('.form-group').find('.form-control').attr('data-missing-error', postalRegionMsg);

    // create array of states
    var arrHtml = [];
    var isStatesAvailable = false;
    Object.keys(c.regions).forEach((s, i) => {
        arrHtml.push('<option id="' + s + '" value="' + s + '">' + c.regions[s] + '</option>');
        isStatesAvailable = true;
    });

    // set state options to the state field
    stateField.html(arrHtml.join('')).removeAttr('disabled');
    if (!isStatesAvailable) {
        stateField.attr('disabled', true);
    }
    // capture the previous value selected
    var stateCode = stateField.val();
    if (stateCode == " ") {
        stateCode = stateField.attr('selected-state');
    }
    if (stateField.attr('data-stateCode') != null) {
        stateCode = stateField.attr('data-stateCode');
    }

    // check if the selected value exists in the options list
    if (stateCode && c.regions[stateCode]) {
        stateField.val(stateCode);
        if (stateCode === '' || stateCode == null) {
            stateField.selectedIndex = 0;
        }
    } else {
        stateField.selectedIndex = 0;
    }

    // update shipping methods since state is changed
    if (form.hasClass('.shipping-form')) {
        shippingHelpers.methods.updateShippingMethodList(form);
    }
}

/**
 * Validates postal code
 * This function triggers on focusout & focusin of the postal field
 */
function validatePostalCode() {
    $('input[name$="_postalCode"]').on('focusout', function () {
        var form = $(this).closest('form');

        var country = form.find('select[name$="_country"]').val();
        if (!country || country.toLowerCase() === 'select country') {
            country = window.Countries.defaultCountry;
        }

        var c = window.Countries[country];
        if ($.isEmptyObject(c)) {
            return;
        }

        var pattern = c.zipCodePattern;
        var regEx = new RegExp(pattern);

        if (country && !regEx.test(this.value)) {
            var errors = {};
            var message = 'Please enter a valid ' + window.Countries[country].postalLabel;
            errors[this.name] = message;
            formHelpers.loadFormErrors(form, errors);
        } else {
            $(this).removeClass('is-invalid');
            $(this).closest('.invalid-feedback').html('');
        }
    });

    return;
}

function initCountriesAndRegions() {
    var countries = $('select[name$="_country"]');

    $.each(countries, function (i, country) {
        $(country).on('change', function () {
            updateStateOptions(country);
            //Update the state field show/hide based on state availability on country change
            var selectedFormId = $('select[name$="_country"]:visible').closest('form').attr('id');
            var appendFormId = selectedFormId ? selectedFormId : 'dwfrm_billing';
            $('#' + appendFormId).find("select[name$='_states_stateCode']").closest('.form-group').parent().removeClass('d-none');
            var stateFormAttr = $('#' + appendFormId).find("select[name$='_states_stateCode'] option");
            if (stateFormAttr.length > 1) {
                $('#' + appendFormId).find("select[name$='_states_stateCode']").closest('.form-group').parent().removeClass('d-none');
            } else {
                $('#' + appendFormId).find("select[name$='_states_stateCode']").closest('.form-group').parent().addClass('d-none');
            }
        });
        updateStateOptions($(country));
        //Hiding state field if selected country dont have state options
        $('.shippingState, .billingState').removeClass('d-none');
        if($('.shipping-form:visible').length && $('.single-shipping .shippingState option').length <= 1) {
            $('.single-shipping .shippingState').closest('.form-group').parent().addClass('d-none');
        } else if ($('.billing-address:visible').length && $('#dwfrm_billing .billingState option').length <= 1) {
            $('#dwfrm_billing .billingState').closest('.form-group').parent().addClass('d-none');
        } else {
            $('.single-shipping .shippingState, #dwfrm_billing .billingState').closest('.form-group').parent().removeClass('d-none');
        }
        //For myaccount hide state if no option
        if($('#state').length && $('#state option').length <= 1) {
            $('#state').closest('.form-group').parent().addClass('d-none');
        }
    });
}

(function () {
    initCountriesAndRegions();
});

module.exports = {
    initCountriesAndRegions: initCountriesAndRegions
};